import { SVGProps } from 'react'

const FuelIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M2 13.3335H9'
                stroke='#959699'
                strokeWidth='1.16667'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M2.5835 5.75H8.41683'
                stroke='#959699'
                strokeWidth='1.16667'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.41683 13.3332V2.83317C8.41683 2.52375 8.29391 2.22701 8.07512 2.00821C7.85633 1.78942 7.55958 1.6665 7.25016 1.6665H3.75016C3.44074 1.6665 3.144 1.78942 2.9252 2.00821C2.70641 2.22701 2.5835 2.52375 2.5835 2.83317V13.3332'
                stroke='#959699'
                strokeWidth='1.16667'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.4165 8.08317H9.58317C9.89259 8.08317 10.1893 8.20609 10.4081 8.42488C10.6269 8.64367 10.7498 8.94042 10.7498 9.24984V10.4165C10.7498 10.7259 10.8728 11.0227 11.0915 11.2415C11.3103 11.4603 11.6071 11.5832 11.9165 11.5832C12.2259 11.5832 12.5227 11.4603 12.7415 11.2415C12.9603 11.0227 13.0832 10.7259 13.0832 10.4165V6.234C13.0833 6.08006 13.0529 5.9276 12.9939 5.78544C12.9348 5.64327 12.8482 5.5142 12.739 5.40567L10.7498 3.4165'
                stroke='#959699'
                strokeWidth='1.16667'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}

export default FuelIcon
